import * as React from "react";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { MainListItems } from "Components/listItems";
import LogoutMenu from "./logoutMenu";
import { useDispatch, useSelector } from "react-redux";
import { fetchBank } from "Redux/Actions/bankActions";
import { fetchPaymentType } from "Redux/Actions/paymentTypeAction";
import Loading from "Components/MUI_components/loading";
import { fetchStockLocation } from "Redux/Actions/stockLocation";

import DefaultLogo from "Components/DefaultLogo/DefaultLogo";
import { Button, Menu, MenuItem, useMediaQuery } from "@mui/material";
import { Description, PhoneIphone } from "@mui/icons-material";
import { mobileLayoutNav } from "./mobileLayoutNavigation";
import { Link } from "react-router-dom";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export default function MiniDrawer(props) {
  const user = useSelector((state) => state.auth);
  const theme = useTheme();

  const [open, setOpen] = React.useState(true);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [reportAnchorEl, setReportAnchorEl] = React.useState(null)
  const openAnchor = Boolean(anchorEl);
  const openReportAnchor = Boolean(reportAnchorEl)

  var pjson = require("../../../package.json");

  const isMobileScreen = useMediaQuery(theme.breakpoints.up('sm'))
  // const isMobileScreen = useMediaQuery(theme.breakpoints.between('xs', 'sm'))
  // const isDesktop = useMediaQuery(theme.breakpoints.up('sm'))

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickReportMenu = (e) => {
    setReportAnchorEl(e.currentTarget)
  }

  const handleCloseReportMenu = () => {
    setReportAnchorEl(null)
  }

  const dispatch = useDispatch();

  const [isLoaded, setIsLoaded] = React.useState(false);

  React.useEffect(() => {
    const fetchInitData = async () => {
      setIsLoaded(true);
      await dispatch(fetchBank());
      await dispatch(fetchPaymentType());
      await dispatch(fetchStockLocation());
      setIsLoaded(false);
      handleDrawerClose()
    };
    fetchInitData();
  }, [dispatch]);

  return (
    <>
      {isLoaded ? (
        <Loading text="Please wait.." noIcon={false} height={"100vh"} />
      ) : (
        <Box sx={{ display: "flex" }}>
          <CssBaseline />
          <AppBar position="fixed" open={open}>
            <Toolbar>
              <IconButton
                color="inherit"
                aria-label="open drawer"
                onClick={handleDrawerOpen}
                edge="start"
                sx={{
                  marginRight: "36px",
                  ...(open && { display: "none" }),
                }}
              >
                <MenuIcon />
              </IconButton>
              <Typography
                sx={{
                  display: {
                    xs: 'none',
                    md: 'block',
                  }
                }}
                variant="h6"
                noWrap
                component="div"
              >
                <p>
                  Version: {pjson.version} &nbsp;| &nbsp; Solution By Titum
                  (PVT) Ltd.
                </p>
              </Typography>

              {/* Menu - Mobile Layout */}
              <Box
                sx={{
                  marginLeft: {
                    xs: -2,
                    md: 10
                  },
                  display: {
                    xs: 'inline-flex',
                    md: 'none'
                  }
                }}
              >
                <Box>
                  <Button
                    id="basic-button"
                    aria-controls={openAnchor ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openAnchor ? "true" : undefined}
                    onClick={handleClick}
                    variant="contained"
                    sx={{
                      backgroundColor: '#126550',
                      color: "#ffffff",
                      minWidth: 'fit-content'
                    }}
                  >
                    <PhoneIphone />
                    <span
                      style={{
                        marginLeft: 2
                      }}
                    >
                      {isMobileScreen ? "Mobile" : ""}
                    </span>
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openAnchor}
                    onClose={handleClose}
                    slotProps={{
                      list: {
                        "aria-labelledby": "basic-button",
                      },
                    }}
                  >
                    {
                      mobileLayoutNav.map((nav) => {
                        return nav.navigation.map((navigation) => {
                          return <MenuItem key={nav.code}>
                            <Link to={navigation.path}
                            onClick={() => {handleClose()}}
                            > 
                              {navigation.label} 
                            </Link>
                          </MenuItem>
                        })
                      })
                    }
                  </Menu>
                </Box>
              </Box>

              {/* Report menu - Mobile layout */}
              <Box
                sx={{
                  marginLeft: {
                    xs: -2,
                    md: 10
                  },
                  display: {
                    xs: 'inline-flex',
                    md: 'none'
                  }
                }}
              >
                <Box>
                  <Button
                    id="report-menu-button"
                    aria-controls={openReportAnchor ? "report-menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={openReportAnchor ? "true" : undefined}
                    onClick={handleClickReportMenu}
                    variant="contained"
                    sx={{
                      backgroundColor: '#126550',
                      color: "#ffffff",
                      marginLeft: {
                        xs: 3,
                        sm: 5
                      },
                      minWidth: 'fit-content'
                    }}
                  >
                    <Description />
                    <span
                      style={{
                        marginLeft: 2
                      }}
                    >
                      {isMobileScreen ? "Reports" : ""}
                    </span>
                  </Button>
                  <Menu
                    id="report-menu"
                    anchorEl={reportAnchorEl}
                    open={openReportAnchor}
                    onClose={handleCloseReportMenu}
                    slotProps={{
                      list: {
                        "aria-labelledby": "report-menu-button",
                      },
                    }}
                  >
                    {
                      mobileLayoutNav.map((nav) => {
                        return nav.reports.map((navigation) => {
                          return <MenuItem key={nav.code}>
                            <Link to={navigation.path}
                            onClick={() => {handleClose()}}
                            > 
                              {navigation.label} 
                            </Link>
                          </MenuItem>
                        })
                      })
                    }
                  </Menu>
                </Box>
              </Box>

              <LogoutMenu user={user?.userData.role[0]} />
            </Toolbar>
          </AppBar>
          <Drawer 
            variant="permanent" 
            open={open}
            sx={{
              display: {
                xs: open ? 'inline-block' : 'none',
                md: 'inline-block'
              }
            }}
          >
            <DrawerHeader
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <DefaultLogo />

              <IconButton  onClick={handleDrawerClose}>
                {theme.direction === "rtl" ? (
                  <ChevronRightIcon />
                ) : (
                  <ChevronLeftIcon />
                )}
              </IconButton>
            </DrawerHeader>
            <Divider />
            <List>
              <MainListItems />
            </List>
            <Divider />
          </Drawer>

          {/* Main content rendering section in dashboard */}
          <Box
            component="main"
            // Responsive
            sx={{ 
              flexGrow: 1, 
              p: {
                md: 3
              }, 
              maxWidth: {
                xs: 500,
                sm: 800,
                md: 1300,
                lg: 1800,
                xl: 2400
              },
              overflowX: {
                xs: 'auto'
              }
            }}
            // End of responsive

            style={{ paddingTop: 85 }}
          >
            {props.children}
          </Box>
        </Box>
      )}
    </>
  );
}